/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HedgeAuditReportResponseData } from '../models/HedgeAuditReportResponseData';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class HedgeAuditService {
    public static getApiHedgeAuditSession({
        sessionId,
        currentPrice,
    }: {
        sessionId: number,
        currentPrice?: number,
    }): CancelablePromise<HedgeAuditReportResponseData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hedgeaudit/session/{sessionId}',
            path: {
                'sessionId': sessionId,
            },
            query: {
                'currentPrice': currentPrice,
            },
        });
    }

    public static postApiHedgeAuditSessionFixes({
        sessionId,
        currentPrice,
    }: {
        sessionId: number,
        currentPrice?: number,
    }): CancelablePromise<HedgeAuditReportResponseData> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/hedgeaudit/session/{sessionId}/fixes',
            path: {
                'sessionId': sessionId,
            },
            query: {
                'currentPrice': currentPrice,
            },
        });
    }
}
